import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react'

const ClientBarcode = () => {
  const [searchParams] = useSearchParams();

  const [info, setInfo] = useState({
    clientName: searchParams.get('clientName'),
    qrCodeList: JSON.parse(decodeURIComponent(localStorage.getItem('qrList'))),
  });

  return (
    <>
      {info?.qrCodeList?.map((item, idx) => (
        <BarcodeFormContainer key={idx}>
          <BarcodeForm>
            <tr>
              <th colSpan={2}>{info.clientName}</th>
            </tr>
            <tr>
              <th>{item.qrName}</th>
              <td><QRCodeSVG value={item.qrCode} size={64}/></td>
            </tr>
            <tr>
              <th>Print Date</th>
              <td>{item.printDate}</td>
            </tr>
          </BarcodeForm>
        </BarcodeFormContainer>
      ))}
    </>
  )
}

const BarcodeFormContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 370px 0;
  padding-top: 10px;
`;

const BarcodeForm = styled.table`
  width: 40%;
  border-collapse: collapse;

  & th:first-child {
    height: 49.5px;
  }

  & th {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
  }

  & td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
    line-height: 16px;
  }
`;

export default ClientBarcode;